// extracted by mini-css-extract-plugin
export var shake = "_q-0";